// SPDX-License-Identifier: AGPL-3.0-or-later

/**
 * Skeleton placeholder. Used in place of spinners so list pages preserve
 * their layout while data is loading. Set `width`/`height` for one-off
 * shapes; the default `.skeleton-row` matches the height of a list-row.
 */
export interface SkeletonProps {
  width?: string | number;
  height?: string | number;
  className?: string;
}

export function Skeleton({ width, height, className }: SkeletonProps) {
  const style: React.CSSProperties = {};
  if (width !== undefined) style.width = typeof width === 'number' ? `${width}px` : width;
  if (height !== undefined) style.height = typeof height === 'number' ? `${height}px` : height;
  const cls = ['skeleton', className].filter(Boolean).join(' ');
  return <span className={cls} style={style} aria-hidden="true" />;
}

export interface SkeletonListProps {
  rows?: number;
  ariaLabel?: string;
}

/**
 * A vertical stack of `skeleton-row`s. Use this in place of a spinner
 * when a list query is loading — it reserves the same vertical space
 * as the real list, which prevents the layout from jumping when data
 * arrives.
 */
export function SkeletonList({ rows = 3, ariaLabel = 'Loading…' }: SkeletonListProps) {
  return (
    <div className="skeleton-list" role="status" aria-label={ariaLabel} aria-live="polite">
      {Array.from({ length: rows }, (_, i) => (
        <Skeleton key={i} className="skeleton-row" />
      ))}
    </div>
  );
}
